import React, { useContext, useState, useEffect } from "react";
import { MusicContext } from "../Context/MusicContext";
import Image15 from "../Images/Image15.png";
import Image15_15 from "../Images/Image15-15.png";
import Star from "../Icons/Star.png";
import "../Styles/Page.css";

function Page15(){
  const { currentTimeRef, language, currentPage } = useContext(MusicContext);
  const [flipped, setFlipped] = useState(true);

  const [, forceUpdate] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      forceUpdate((n) => n + 1);
    }, 200); 
    return () => clearInterval(interval);
  }, []);

   function stop(e){
    e.stopPropagation();
    e.preventDefault()
    if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation){
      e.nativeEvent.stopImmediatePropagation();
    }
  };

    function handleToggle(e){
    e.stopPropagation();
    setFlipped((prev) => !prev);
  };

  const transcripts = {
     en: {
      dropCap: "E",
      dropCapText: "VERY MORNING,",
      lines:[
    { text: "Amile sneaked outside with a cup of water and poured it over the plant's soil.", start: 0, end: 6.3 },
    { text: "Her parents would have been angry if they found out,", start: 6.4, end: 9.2 },
    { text: "but she couldn’t help it,", start: 9.3, end: 10.4 },
    { text: "she needed to know what the seed would become.", start: 10.5, end: 13.3 },
    ]
  },
    zu: {
    dropCap: "N",
    dropCapText: "JALO EKUSENI,",
    lines: [
    { text: "uAmile wayenyonyoba ngaphandle nenkomishi yamanzi ukuyonisela isitshalo.", start: 0, end: 7 },
    { text: "Abazali bakhe babeyothukuthela kabi uma bengamthola,", start: 7.1, end: 11 },
    { text: "kodwa wayengakwazi ukuzibamba,", start: 11.1, end: 13.2 },
    { text: "wayedinga ukwazi ukuthi leyo mbewu izoba yini.", start: 13.3, end: 16.2 },
      ]
    }
  };
      const { dropCap, dropCapText, lines } = transcripts[language];
      const currentTime = currentTimeRef.current;
  
  return(
    <section className="page">
    <section className="drop-cap-container">
      <section className="drop-cap">{dropCap}</section>
      <section className="drop-cap-text">{dropCapText}</section>
    </section>

      <p className="page-chapter">
        {lines.map((line, i) => {
        const isActive = currentPage === 15 && currentTime >= line.start && currentTime <= line.end;
          return(
            <span key={i} className={isActive ? "highlight" : ""}>
              {line.text + " "}
            </span>
          );
        })}
      </p>

    <section className="image-wrapper" onClick={stop} onPointerDown={stop} onMouseDown={stop} onTouchStart={stop}>
     {flipped ? (
          <img src={Image15} alt="Page 15" className="page-image-15" />
        ) : (
          <img src={Image15_15} alt="Page 15" className="page-image-15-15" />
        )}

      <img src={Star} alt="Star" className="star-indicator" onClick={handleToggle} />
      </section>
      <section className="odd">15</section>
    </section>
  );
}

export default Page15;